import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const QUERY_KEY = 'GET_ORGANIZATION_LOCK_STATUS';
const useGetOrgLockStatusQuery = (id?: string) => {
  const { data, isLoading, isSuccess, isError } = useQuery(
    [QUERY_KEY, id],
    () => api.get(API_URL.ORGANIZATION_LOCKS_BY_ORGANIZATION_ID(id || '')),
    {
      enabled: !!id,
      retry: 0,
    }
  );

  const formattedData = useMemo(() => {
    return {
      isLocked: data?.data?.is_locked,
      organizationId: data?.data?.organization_id,
    };
  }, [data]);

  return {
    formattedData,
    isLoading,
    isSuccess,
    isError,
  };
};

export default useGetOrgLockStatusQuery;
